import React from 'react';

const ServiceOne = () => {
    return(
        <div className="Services__service">
            <div className="Services__title">
                <h2>Nice Looking</h2> <strong>Frontend</strong>
            </div>
            <p className="Services__text">
                I can create a <strong>nice looking</strong>, <strong>clean</strong> and <strong>creative</strong> frontend to display all the info you need to your users. I'm well-versed in React, even certified in it!
            </p>
        </div>
    )
}

const ServiceTwo = () => {
    return (
        <div className="Services__service">
            <div className="Services__title">
                <h2>All-Around</h2> <strong>Web App</strong>
            </div>
            <p className="Services__text">
                Basically, I can help you get things <strong>done </strong>with your web projects. Not only to get things done, but to elevate the <strong>quality </strong> of the things that get done.
            </p>
        </div>
    )
}

const ServiceThree = () => {
    return (
        <div className="Services__service">
            <div className="Services__title">
            <h2>Well-Performing</h2> <strong>Backend</strong>
            </div>
            <p className="Services__text">
                If it is a backend you want, I can use <strong>NodeJS </strong>, <strong>Express </strong> and <strong>MongoDB </strong> to help you out with it. Let's make great backends for our projects!
            </p>
        </div>
    )
}
  
const Services = () => {
    return(
        <div>
            <h2 className="Premise">I can help <span className="bullshitGimmick">you</span> create a...</h2>
            <div className="Services">
                <ServiceOne></ServiceOne>
                <ServiceTwo></ServiceTwo>
                <ServiceThree></ServiceThree>
            </div>
        </div>
    )   
}

export default Services;